import { getDistanceFromLatLonInKm } from '../utils/helpers';

class LocationSearch {
  constructor(selector, { onSearch, onClosest, onOptionClick, onChange } = {}) {
    this.$container = $(selector);
    this.$input = this.$container.find('.search__input');
    this.$dropdown = this.$container.find('.search__dropdown');
    this.$form = this.$container.find('.search__form');
    this.$submit = this.$container.find('.search__submit');
    this.$geolocation = this.$container.find('.search__geolocation');
    this.$options = this.$dropdown.find('.search__option');

    this.options = this.$options.map((i, el) => ({
      title: $(el).data('title'),
      area: $(el).data('area'),
      lat: $(el).data('lat'),
      lng: $(el).data('lng'),
      link: $(el).data('link'),
    }));
    this.value = '';
    this.mapPagePath = '/pizzerias/';

    // props
    this.onClosest = onClosest;
    this.onSearch = onSearch;
    this.onOptionClick = onOptionClick;
    this.onChange = onChange;

    this.init();
  }

  init() {
    this.$input.on('input', this.handleInput.bind(this));
    this.$form.on('submit', this.handleSubmit.bind(this));
    this.$submit.on('click', this.handleSubmit.bind(this));
    this.$geolocation.on('click', this.handleGeolocation.bind(this));
    this.$options.on('click', this.handleOptionClick.bind(this));

    if (!('geolocation' in navigator)) {
      this.$geolocation.addClass('is-hidden');
    }
  }

  handleGeolocation() {
    this.$container.addClass('is-searching');

    navigator.geolocation.getCurrentPosition((position) => {
      this.findClosestPizzeria(position.coords);
    });
  }

  findClosestPizzeria({ latitude, longitude }) {
    const pizzerias = [];

    // calculate distance to each location
    this.options.each((i, option) => {
      if (option.lat && option.lng) {
        const distance = getDistanceFromLatLonInKm(
          latitude,
          longitude,
          option.lat,
          option.lng
        );

        pizzerias.push({
          details: option,
          distance,
        });
      } else {
        pizzerias.push({
          details: option,
          distance: null,
        });
      }
    });

    // order locations by distance
    const sortedPizzerias = pizzerias.sort((a, b) => {
      if (a.distance === null) return 1;
      if (b.distance === null) return -1;
      return a.distance - b.distance;
    });

    // closest
    const closestPizzeria = sortedPizzerias[0].details;

    this.$container.removeClass('is-searching');

    if (this.onClosest) {
      this.onClosest(closestPizzeria);
      this.setValue(closestPizzeria.title);
    } else {
      // redirect to pizzeria page
      window.location.href = closestPizzeria.link;
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.onSearch) {
      this.onSearch(this.value);
    } else {
      const url = new URL(`${window.location.origin}${this.mapPagePath}`);
      if (this.value) url.searchParams.set('location', this.value);
      window.location.href = url;
    }
  }

  handleInput(e) {
    this.value = e.target.value;
    const formattedValue = this.value.toLowerCase().trim();
    let isFound = false;

    // reset dropdown
    this.$dropdown.html('');

    this.options.each((i, option) => {
      if (
        option.title.toLowerCase().includes(formattedValue) ||
        option.area.toLowerCase().includes(formattedValue)
      ) {
        isFound = true;
        this.$dropdown.append(this.$options.eq(i));
      }
    });

    if (isFound) {
      this.$container.removeClass('is-dropdown-hidden');
    } else {
      this.$container.addClass('is-dropdown-hidden');
    }

    // disable search button
    if (!this.value) {
      this.$submit.prop('disabled', true);
    } else {
      this.$submit.prop('disabled', false);
    }

    this.$container.removeClass('is-not-found');

    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  handleOptionClick(e) {
    if (this.onOptionClick) {
      e.preventDefault();
      const index = this.$options.index(e.currentTarget);
      const option = this.options[index];
      this.onOptionClick(option);
      this.setValue(option.title);
    }
  }

  setValue(value) {
    this.value = value;
    this.$input.val(value);
  }

  noResultsFound() {
    this.$container.addClass('is-not-found');
  }
}

export default LocationSearch;
